import './Layout.css';
import './Layout.Reset.css';

export default ({ children }) => children;
